export const EVENT_OBJECT = {
  exitIntend: 'ExitIntend',
  button: 'Button',
  headerLink: 'HeaderLink',
  footerLink: 'FooterLink',
};

export const EVENT_VERB = {
  interacted: 'Interacted',
  seen: 'Seen',
  aborted: 'Aborted',
};

/**
 * List of all available groups used for segment tracking.
 *
 * The list should prevent typing errors and a comfortable overview about existing ones.
 * All properties are written in snake_case.
 */
export const GROUP = {
  exitIntend: 'exit_intend',
};

/**
 * Helper to construct event names according to the guideline.
 *
 * The function should prevent typing errors and give a comfortable overview about existing ones.
 * All event names consists of an Object and a Verb connected by a space.
 * Each Object and each Verb is written in capitalized camelCase and Verbs are written in past form.
 * If needed an optional third Value can be attached to the end for further distinction.
 *
 * @example CreditPurchase Aborted
 *
 * @param object The meaningful topic the event belongs to.
 * @param verb The action the user executed.
 * @param value An individual parameter which is significant for analytics. As every combination creates a new event the possibilities should be few.
 */
export const eventBuilder = (object, verb, value) =>
  (object?.length &&
    verb?.length &&
    [object, verb, value].filter(Boolean).join(' ')) ||
  '';

/**
 * Sends a tracking event if analytics is activated.
 * Besides the given information it also adds some basic information like the current page the tracking was executed.
 * @param event {string}
 * @param params {object=} - Additional parameter like group, to, label...
 */
export const analyticsTrack = ({ event, params }) =>
  window?.analytics?.track(event, {
    path: window.location.pathname,
    pathOrigin: window.location.origin,
    ...params,
  });
